import React from "react";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
import { ProductsContext } from "../../context/ProductsContext";
import ST4_odds from "../../consts/ST4_odds";
import ST4_odds_old from "../../consts/ST4_odds_old";
import products from "../../consts/products";
import { useLocation, Link } from "react-router-dom";
const Question13 = ({ deleteStep , addStep, answer6_13_points, answer1_5 }) => {
  const { p1, p1_old, p4, p4_old } = React.useContext(ProductsContext);
  const [product1, setProduct1] = p1;
  const [product1_old, setProduct1_old] = p1_old;
  const [product4, setProduct4] = p4;
  const [product4_old, setProduct4_old] = p4_old;
  const answerHandler = (option) => {
    addStep();

    let points = answer6_13_points + option;

    let d_level = DamageLevelHandler(points);

    product4Handler(d_level);
    product4Handler_old(d_level);
  };
  const DamageLevelHandler = (points) => {
    let d_level = "";
    switch (true) {
      case points <= 4:
        d_level = "option1";
        break;
      case points >= 5 && points <= 11:
        d_level = "option2";
        break;
      case points >= 12:
        d_level = "option3";
    }

    return d_level;
  };

  const product4Handler = (d_level) => {
    const result4 = ST4_odds.find(
      (i) => i.d_level === d_level && i.product1 === product1.id
    );
    const product4 = products.find((p) => p.id === result4.product);
    setProduct4(product4);
  };
  const product4Handler_old = (d_level) => {
    const result4_old = ST4_odds_old.find(
      (i) => i.d_level === d_level && i.product1 === product1.id
    );
    const product4_old = products.find((p) => p.id === result4_old.product);
    setProduct4_old(product4_old);
  };
  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>
   
      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            14 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section className="c-question__content p-question__content p-question__content--3 c-box2">
        <h1 className="c-question__title">お風呂上りには毎回髪を乾かしている？</h1>
        <section
          onClick={() => {
            answerHandler(0);
          }}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>乾かしている</p>
        </section>
        <section
          onClick={() => {
            answerHandler(1);
          }}
          className="c-question__option p-question__option p-question__option--3"
        >
          <p>乾かしていない</p>
        </section>
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question13;
